<!--<template>-->
<!--	<div class="edit-container">-->
<!--		<div class="header">-->
<!--			<h2>Edit Device</h2>-->
<!--			<button class="close-btn" @click="$emit('close')">✕</button>-->
<!--		</div>-->
<!--		-->
<!--		<form @submit.prevent="saveChanges" class="edit-form">-->
<!--			<div class="form-group">-->
<!--				<label for="tv-name">Device Name</label>-->
<!--				<input-->
<!--						id="tv-name"-->
<!--						v-model="form.name"-->
<!--						type="text"-->
<!--						required-->
<!--						maxlength="255"-->
<!--						placeholder="e.g., Bar TV 1"-->
<!--				>-->
<!--			</div>-->
<!--			-->
<!--			<div class="form-group">-->
<!--				<label for="tv-group">-->
<!--					<Icon name="tv-groups" size="xs"/>-->
<!--					Group-->
<!--				</label>-->
<!--				<select id="tv-group" v-model="form.group_id">-->
<!--					<option :value="null">No Group</option>-->
<!--					<option-->
<!--							v-for="group in availableGroups"-->
<!--							:key="group.id"-->
<!--							:value="group.id"-->
<!--					>-->
<!--						{{ group.name }}-->
<!--					</option>-->
<!--				</select>-->
<!--			</div>-->
<!--			-->
<!--			<div class="form-group">-->
<!--				<label for="default-app">-->
<!--					<Icon name="app" size="xs"/>-->
<!--					Default App-->
<!--				</label>-->
<!--				<select id="default-app" v-model="form.default_app">-->
<!--					<option value="none">No Default App</option>-->
<!--					<option-->
<!--							v-for="app in availableApps"-->
<!--							:key="app.key"-->
<!--							:value="app.key"-->
<!--					>-->
<!--						{{ app.label }}-->
<!--					</option>-->
<!--				</select>-->
<!--			</div>-->
<!--			-->
<!--			<div class="form-actions">-->
<!--				<button type="button" class="btn-secondary" @click="$emit('close')">-->
<!--					Cancel-->
<!--				</button>-->
<!--				<button type="submit" class="btn-primary" :disabled="isSaving">-->
<!--					{{ isSaving ? 'Saving...' : 'Save Changes' }}-->
<!--				</button>-->
<!--			</div>-->
<!--			-->
<!--			<div class="delete-section">-->
<!--				<button type="button" class="btn-danger" @click="showDeleteConfirm = true">-->
<!--					<Icon name="trash" size="sm"/>-->
<!--					Delete Device-->
<!--				</button>-->
<!--			</div>-->
<!--		</form>-->
<!--		-->
<!--		<Modal-->
<!--			:show="showDeleteConfirm"-->
<!--			title="Delete Device"-->
<!--			confirm-text="Delete Device"-->
<!--			confirm-button-class="danger"-->
<!--			:confirm-disabled="isDeleting"-->
<!--			@close="showDeleteConfirm = false"-->
<!--			@cancel="showDeleteConfirm = false"-->
<!--			@confirm="deleteDevice"-->
<!--		>-->
<!--			<div class="delete-confirmation">-->
<!--				<p>Are you sure you want to delete<br><strong>{{ props.tv.name }}</strong>?</p>-->
<!--				<p class="warning-text">This action cannot be undone. The device will be unpaired and removed from all-->
<!--					groups.</p>-->
<!--			</div>-->
<!--		</Modal>-->
<!--	</div>-->
<!--</template>-->

<!--<script setup>-->
<!--import {ref, computed, onMounted} from 'vue'-->
<!--import {useMainStore} from '../store/main'-->
<!--import Icon from "./Icon.vue";-->
<!--import Modal from "./Modal.vue";-->

<!--const props = defineProps({-->
<!--	tv: {type: Object, required: true}-->
<!--})-->

<!--const emit = defineEmits(['close', 'saved', 'deleted'])-->

<!--const store = useMainStore()-->
<!--const isSaving = ref(false)-->
<!--const isDeleting = ref(false)-->
<!--const showDeleteConfirm = ref(false)-->

<!--const form = ref({-->
<!--	name: props.tv.name,-->
<!--	group_id: props.tv.group?.id || null,-->
<!--	default_app: props.tv.default_app?.key || 'none'-->
<!--})-->

<!--const availableGroups = computed(() => store.groups)-->
<!--const availableApps = computed(() => {-->
<!--	// Add "No Default App" option at the beginning-->
<!--	return [-->
<!--		{key: 'none', label: 'No Default App'},-->
<!--		...store.apps-->
<!--	]-->
<!--})-->

<!--async function saveChanges() {-->
<!--	isSaving.value = true-->
<!--	-->
<!--	try {-->
<!--		const response = await fetch(`/api/tvs/${props.tv.id}`, {-->
<!--			method: 'PATCH',-->
<!--			headers: {-->
<!--				'Authorization': `Bearer ${sessionStorage.getItem('buzztime_token')}`,-->
<!--				'Content-Type': 'application/json'-->
<!--			},-->
<!--			body: JSON.stringify({-->
<!--				name: form.value.name,-->
<!--				group_id: form.value.group_id,-->
<!--				default_app: form.value.default_app === 'none' ? null : form.value.default_app-->
<!--			})-->
<!--		})-->
<!--		-->
<!--		if (response.ok) {-->
<!--			const updatedTv = await response.json()-->
<!--			emit('saved', updatedTv.tv)-->
<!--			emit('close')-->
<!--		} else {-->
<!--			const error = await response.json()-->
<!--			alert(`Failed to save: ${error.message}`)-->
<!--		}-->
<!--	} catch (error) {-->
<!--		alert('Failed to save changes')-->
<!--		console.error('Save error:', error)-->
<!--	} finally {-->
<!--		isSaving.value = false-->
<!--	}-->
<!--}-->

<!--async function deleteDevice() {-->
<!--	isDeleting.value = true-->
<!--	-->
<!--	try {-->
<!--		const response = await fetch(`/api/tvs/${props.tv.id}`, {-->
<!--			method: 'DELETE',-->
<!--			headers: {-->
<!--				'Authorization': `Bearer ${sessionStorage.getItem('buzztime_token')}`-->
<!--			}-->
<!--		})-->
<!--		-->
<!--		if (response.ok) {-->
<!--			emit('deleted', props.tv)-->
<!--			emit('close')-->
<!--		} else {-->
<!--			const error = await response.json()-->
<!--			alert(`Failed to delete device: ${error.message}`)-->
<!--		}-->
<!--	} catch (error) {-->
<!--		alert('Failed to delete device')-->
<!--		console.error('Delete error:', error)-->
<!--	} finally {-->
<!--		isDeleting.value = false-->
<!--		showDeleteConfirm.value = false-->
<!--	}-->
<!--}-->

<!--onMounted(async () => {-->
<!--	if (store.apps.length === 0) {-->
<!--		await store.loadApps()-->
<!--	}-->
<!--})-->
<!--</script>-->

<!--<style scoped>-->
<!--.edit-container {-->
<!--	background: var(&#45;&#45;color-popup-dark);-->
<!--	border: var(&#45;&#45;border-thin) var(&#45;&#45;color-border);-->
<!--	border-radius: var(&#45;&#45;border-radius-lg);-->
<!--	padding: var(&#45;&#45;spacing-xl);-->
<!--	max-width: 400px;-->
<!--	margin: var(&#45;&#45;spacing-lg) auto;-->
<!--}-->

<!--.header {-->
<!--	display: flex;-->
<!--	justify-content: space-between;-->
<!--	align-items: center;-->
<!--	margin-bottom: var(&#45;&#45;spacing-lg);-->
<!--}-->

<!--.header h2 {-->
<!--	margin: 0;-->
<!--	color: var(&#45;&#45;color-text);-->
<!--}-->

<!--.close-btn {-->
<!--	background: none;-->
<!--	border: none;-->
<!--	color: var(&#45;&#45;color-text-secondary);-->
<!--	font-size: 1.2rem;-->
<!--	cursor: pointer;-->
<!--	padding: var(&#45;&#45;spacing-sm);-->
<!--	border-radius: var(&#45;&#45;border-radius-sm);-->
<!--}-->

<!--.close-btn:hover {-->
<!--	background: var(&#45;&#45;color-popup-element);-->
<!--}-->

<!--.edit-form {-->
<!--	display: flex;-->
<!--	flex-direction: column;-->
<!--	gap: var(&#45;&#45;spacing-lg);-->
<!--}-->

<!--.form-group {-->
<!--	display: flex;-->
<!--	flex-direction: column;-->
<!--	gap: var(&#45;&#45;spacing-sm);-->
<!--}-->

<!--.form-group label {-->
<!--	font-size: var(&#45;&#45;font-size-sm);-->
<!--	color: var(&#45;&#45;color-text-secondary);-->
<!--	font-weight: var(&#45;&#45;font-weight-medium);-->
<!--}-->

<!--.form-group input,-->
<!--.form-group select {-->
<!--	background: var(&#45;&#45;color-popup);-->
<!--	border: var(&#45;&#45;border-thin) var(&#45;&#45;color-border);-->
<!--	border-radius: var(&#45;&#45;border-radius-md);-->
<!--	padding: var(&#45;&#45;spacing-md);-->
<!--	color: var(&#45;&#45;color-text);-->
<!--	font-size: var(&#45;&#45;font-size-base);-->
<!--}-->

<!--.form-group input:focus,-->
<!--.form-group select:focus {-->
<!--	outline: none;-->
<!--	border-color: var(&#45;&#45;color-primary);-->
<!--}-->

<!--.form-actions {-->
<!--	display: flex;-->
<!--	gap: var(&#45;&#45;spacing-md);-->
<!--	margin-top: var(&#45;&#45;spacing-lg);-->
<!--}-->

<!--.delete-section {-->
<!--	margin-top: var(&#45;&#45;spacing-lg);-->
<!--	padding-top: var(&#45;&#45;spacing-lg);-->
<!--	border-top: var(&#45;&#45;border-thin) var(&#45;&#45;color-border);-->
<!--}-->

<!--.delete-confirmation {-->
<!--	text-align: center;-->
<!--}-->

<!--.delete-confirmation p {-->
<!--	margin: 0 0 var(&#45;&#45;spacing-md) 0;-->
<!--	color: var(&#45;&#45;color-text);-->
<!--}-->

<!--.warning-text {-->
<!--	font-size: var(&#45;&#45;font-size-sm);-->
<!--	color: var(&#45;&#45;color-text-secondary);-->
<!--}-->

<!--.btn-primary,-->
<!--.btn-secondary {-->
<!--	flex: 1;-->
<!--	padding: var(&#45;&#45;spacing-md) var(&#45;&#45;spacing-lg);-->
<!--	border: none;-->
<!--	border-radius: var(&#45;&#45;border-radius-md);-->
<!--	font-size: var(&#45;&#45;font-size-sm);-->
<!--	font-weight: var(&#45;&#45;font-weight-medium);-->
<!--	cursor: pointer;-->
<!--	transition: all var(&#45;&#45;transition-fast);-->
<!--}-->

<!--.btn-primary {-->
<!--	background: var(&#45;&#45;color-primary);-->
<!--	color: white;-->
<!--}-->

<!--.btn-primary:hover:not(:disabled) {-->
<!--	background: var(&#45;&#45;color-primary-hover);-->
<!--}-->

<!--.btn-secondary {-->
<!--	background: var(&#45;&#45;color-popup-element);-->
<!--	color: var(&#45;&#45;color-text);-->
<!--}-->

<!--.btn-secondary:hover {-->
<!--	background: var(&#45;&#45;color-popup-light);-->
<!--}-->

<!--.btn-primary:disabled {-->
<!--	opacity: 0.6;-->
<!--	cursor: not-allowed;-->
<!--}-->
<!--</style>-->

<template>
	<div class="edit-container">
		<div class="header">
			<h2>Edit Device</h2>
			<button class="close-btn" @click="$emit('close')" :disabled="isDeleting">✕</button>
		</div>
		
		<form @submit.prevent="saveChanges" class="edit-form">
			<div class="form-group">
				<label for="tv-name">Device Name</label>
				<input
						id="tv-name"
						v-model="form.name"
						type="text"
						required
						maxlength="255"
						placeholder="e.g., Bar TV 1"
						:disabled="isDeleting"
				>
			</div>
			
			<div class="form-group">
				<label for="tv-group">
					<Icon name="tv-groups" size="xs"/>
					Group
				</label>
				<select id="tv-group" v-model="form.group_id" :disabled="isDeleting">
					<option :value="null">No Group</option>
					<option
							v-for="group in availableGroups"
							:key="group.id"
							:value="group.id"
					>
						{{ group.name }}
					</option>
				</select>
			</div>
			
			<div class="form-group">
				<label for="default-app">
					<Icon name="app" size="xs"/>
					Default App
				</label>
				<select id="default-app" v-model="form.default_app" :disabled="isDeleting">
					<option value="none">No Default App</option>
					<option
							v-for="app in availableApps"
							:key="app.key"
							:value="app.key"
					>
						{{ app.label }}
					</option>
				</select>
			</div>
			
			<!-- Error Message Display -->
			<div v-if="errorMessage" class="error-message">
				<Icon name="warning" size="sm"/>
				<span>{{ errorMessage }}</span>
			</div>
			
			<div class="form-actions">
				<button type="button" class="btn-secondary" @click="$emit('close')" :disabled="isSaving || isDeleting">
					Cancel
				</button>
				<button type="submit" class="btn-primary" :disabled="isSaving || isDeleting">
					{{ isSaving ? 'Saving...' : 'Save Changes' }}
				</button>
			</div>
			
			<!-- Delete Button -->
			<div class="delete-section">
				<button type="button" class="btn-danger" @click="showDeleteConfirm = true"
						:disabled="isSaving || isDeleting">
					<Icon name="trash" size="sm"/>
					Delete Device
				</button>
			</div>
		</form>
		
		<!-- Simple Delete Confirmation Modal -->
		<Modal
				:show="showDeleteConfirm"
				title="Delete Device"
				:confirm-text="isDeleting ? 'Deleting...' : 'Delete Device'"
				confirm-button-class="danger"
				:confirm-disabled="isDeleting"
				:close-on-overlay="!isDeleting"
				@close="showDeleteConfirm = false"
				@cancel="showDeleteConfirm = false"
				@confirm="deleteDevice"
		>
			<div class="delete-confirmation">
				<div v-if="isDeleting" class="deleting-state">
					<Icon name="loading" size="md"/>
					<p>Deleting {{ props.tv.name }}...</p>
				</div>
				<div v-else>
					<p>Are you sure you want to delete <strong>{{ props.tv.name }}</strong>?</p>
					<p class="warning-text">This action cannot be undone.</p>
				</div>
				
				<!-- Error Message in Modal -->
				<div v-if="deleteErrorMessage" class="error-message">
					<Icon name="warning" size="sm"/>
					<span>{{ deleteErrorMessage }}</span>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import {useRouter} from 'vue-router'
import {useMainStore} from '../store/main'
import {requestDeviceDeletion, updateDevice} from '../utils/api'
import Icon from "./Icon.vue"
import Modal from "./Modal.vue"

const props = defineProps({
	tv: {type: Object, required: true}
})

const emit = defineEmits(['close', 'saved', 'deleted'])

const router = useRouter()
const store = useMainStore()
const isSaving = ref(false)
const isDeleting = ref(false)
const showDeleteConfirm = ref(false)
const errorMessage = ref('')
const deleteErrorMessage = ref('')

const form = ref({
	name: props.tv.name,
	group_id: props.tv.group?.id || null,
	default_app: props.tv.default_app?.key || 'none'
})

const availableGroups = computed(() => store.groups)
const availableApps = computed(() => {
	return [
		{key: 'none', label: 'No Default App'},
		...store.apps
	]
})

async function saveChanges() {
	isSaving.value = true
	errorMessage.value = ''
	
	const result = await updateDevice(props.tv.id, {
		name: form.value.name,
		group_id: form.value.group_id,
		default_app: form.value.default_app === 'none' ? null : form.value.default_app
	})
	
	if (result.success) {
		emit('saved', result.data)
		emit('close')
	} else {
		errorMessage.value = result.error
	}
	
	isSaving.value = false
}

async function deleteDevice() {
	isDeleting.value = true
	deleteErrorMessage.value = ''
	
	const result = await requestDeviceDeletion(props.tv.id)
	
	if (result.success) {
		// Remove from store
		const index = store.pairedTVs.findIndex(t => t.id === props.tv.id)
		if (index !== -1) {
			store.pairedTVs.splice(index, 1)
		}
		
		// Emit events and navigate
		emit('deleted', props.tv)
		emit('close')
		router.push('/home')
	} else {
		deleteErrorMessage.value = result.error
	}
	
	isDeleting.value = false
}

onMounted(async () => {
	if (store.apps.length === 0) {
		await store.loadApps()
	}
})
</script>

<style scoped>
.edit-container {
	background: var(--color-popup-dark);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-lg);
	padding: var(--spacing-xl);
	max-width: 400px;
	margin: var(--spacing-lg) auto;
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: var(--spacing-lg);
}

.header h2 {
	margin: 0;
	color: var(--color-text);
}

.close-btn {
	background: none;
	border: none;
	color: var(--color-text-secondary);
	font-size: 1.2rem;
	cursor: pointer;
	padding: var(--spacing-sm);
	border-radius: var(--border-radius-sm);
}

.close-btn:hover:not(:disabled) {
	background: var(--color-popup-element);
}

.close-btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.edit-form {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-lg);
}

.form-group {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-sm);
}

.form-group label {
	font-size: var(--font-size-sm);
	color: var(--color-text-secondary);
	font-weight: var(--font-weight-medium);
	display: flex;
	align-items: center;
	gap: var(--spacing-xs);
}

.form-group input,
.form-group select {
	background: var(--color-popup);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
	padding: var(--spacing-md);
	color: var(--color-text);
	font-size: var(--font-size-base);
}

.form-group input:focus,
.form-group select:focus {
	outline: none;
	border-color: var(--color-primary);
}

.form-group input:disabled,
.form-group select:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.error-message {
	display: flex;
	align-items: center;
	gap: var(--spacing-xs);
	padding: var(--spacing-md);
	background: rgba(255, 68, 68, 0.1);
	border: var(--border-thin) var(--color-error);
	border-radius: var(--border-radius-md);
	color: var(--color-error);
	font-size: var(--font-size-sm);
}

.form-actions {
	display: flex;
	gap: var(--spacing-md);
	margin-top: var(--spacing-lg);
}

.delete-section {
	margin-top: var(--spacing-lg);
	padding-top: var(--spacing-lg);
	border-top: var(--border-thin) var(--color-border);
}

.btn-primary,
.btn-secondary,
.btn-danger {
	flex: 1;
	padding: var(--spacing-md) var(--spacing-lg);
	border: none;
	border-radius: var(--border-radius-md);
	font-size: var(--font-size-sm);
	font-weight: var(--font-weight-medium);
	cursor: pointer;
	transition: all var(--transition-fast);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--spacing-xs);
}

.btn-primary {
	background: var(--color-primary);
	color: white;
}

.btn-primary:hover:not(:disabled) {
	background: var(--color-primary-hover);
}

.btn-secondary {
	background: var(--color-popup-element);
	color: var(--color-text);
}

.btn-secondary:hover:not(:disabled) {
	background: var(--color-popup-light);
}

.btn-danger {
	background: var(--color-error);
	color: white;
	width: 100%;
}

.btn-danger:hover:not(:disabled) {
	background: var(--color-error-hover, #d32f2f);
}

.btn-primary:disabled,
.btn-secondary:disabled,
.btn-danger:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.delete-confirmation {
	text-align: center;
}

.delete-confirmation p {
	margin: 0 0 var(--spacing-md) 0;
	color: var(--color-text);
}

.warning-text {
	font-size: var(--font-size-sm);
	color: var(--color-text-secondary);
}

.deleting-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--spacing-md);
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>